import styled from "@emotion/styled";

export const SubLabel = styled("span")(() => ({
  fontWeight: 500,
}));
